import { render, staticRenderFns } from "./HotRecommend.vue?vue&type=template&id=1c07e021&scoped=true&"
import script from "./HotRecommend.vue?vue&type=script&lang=js&"
export * from "./HotRecommend.vue?vue&type=script&lang=js&"
import style0 from "./HotRecommend.vue?vue&type=style&index=0&id=1c07e021&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c07e021",
  null
  
)

export default component.exports